var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4374 1.49962C11.3526 1.18315 11.1496 0.918583 10.8659 0.754801C10.2802 0.416639 9.52854 0.617956 9.19028 1.2038L9.00147 1.53078L8.81267 1.20375C8.47446 0.618054 7.72282 0.416639 7.13707 0.754752H7.13702C6.55127 1.09296 6.3499 1.8446 6.68807 2.4304L7.58504 3.98402L4.27535 9.71663H1.86239C1.18602 9.71663 0.635742 10.2669 0.635742 10.9433C0.635742 11.6197 1.18602 12.1699 1.86239 12.1699H11.178L9.7616 9.71663H7.10817L11.3148 2.43045C11.4787 2.1467 11.5222 1.8161 11.4374 1.49962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1389 9.71658H13.7259L10.9828 4.96533L9.56641 7.41863L13.8255 14.7956C13.9893 15.0794 14.2538 15.2824 14.5704 15.3672C14.6761 15.3955 14.7833 15.4095 14.8899 15.4095C15.1024 15.4095 15.3122 15.3538 15.5013 15.2446C16.087 14.9064 16.2884 14.1547 15.9502 13.569L15.1423 12.1699H16.1389C16.8152 12.1699 17.3655 11.6196 17.3655 10.9432C17.3655 10.2669 16.8152 9.71658 16.1389 9.71658Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29108 13.1514L2.04982 13.5692C1.71166 14.155 1.91308 14.9066 2.49883 15.2448C2.69151 15.356 2.9021 15.4089 3.11009 15.4089C3.53431 15.4089 3.94749 15.1889 4.17447 14.7958L5.1239 13.1514H2.29108Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/AppleStore.be4ef6825b5d882ea9bcb41995d892ec.svg";
export { ForwardRef as ReactComponent };